import React from 'react';
import { LookupEditTemplate } from 'themes/modules/lookup/pages';
import { LookupEditViewStore } from 'modules/lookup/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new LookupEditViewStore(rootStore, componentProps), 'lookupEditViewStore')
class LookupEdit extends React.Component {
	render() {
		return <LookupEditTemplate {...this.props} />;
	}
}

export default LookupEdit;



// WEBPACK FOOTER //
// ./src/modules/lookup/pages/LookupEdit.jsx